<section>
  <span class="d-block text-md mb-2">{{ 'wizards:entityWizards.company.administratorsStep.description' | i18next }}</span>

  <span class="d-block text-md mb-3">{{ 'wizards:entityWizards.company.administratorsStep.existingHint' | i18next }}</span>

  <mbs-button
    icon="ico ico-Plus"
    [id]="elementSelectors.id.createButton"
    (click)="createAdministratorClickHandler()">
    {{ 'wizards:entityWizards.company.administratorsStep.createButton' | i18next }}
  </mbs-button>

  <span class="d-block text-md mt-3 mb-2">{{ 'wizards:entityWizards.company.administratorsStep.gridDescription' | i18next }}</span>

  <mbs-table-grid
    listType="table"
    [data]="value().administrators"
    [disableViewSwitch]="true"
    [headers]="headers"
    [id]="elementSelectors.id.table"
    [loading]="loading()"
    [selectable]="false"
    [showHeaders]="true"
    [switcherView]="false">
    <ng-template
      let-administrator
      mbsTableCell>
      <mbs-text-ellipsis
        placement="top-left auto"
        tooltipClass="tooltip-lg"
        [tooltip]="administrator.firstName">
        {{ administrator.firstName || '-' }}
      </mbs-text-ellipsis>
    </ng-template>

    <ng-template
      let-administrator
      mbsTableCell>
      <mbs-text-ellipsis
        placement="top-left auto"
        tooltipClass="tooltip-lg"
        [tooltip]="administrator.lastName">
        {{ administrator.lastName || '-' }}
      </mbs-text-ellipsis>
    </ng-template>

    <ng-template
      let-administrator
      mbsTableCell>
      <mbs-text-ellipsis
        placement="top-left auto"
        tooltipClass="tooltip-lg"
        [tooltip]="administrator.email">
        <ng-template
          mbsTextEllipsisPrepend
          [hide]="!administrator.isProvider">
          <span class="mr-2 ico ico-crown text-yellow"></span>
        </ng-template>
        {{ administrator.email }}
      </mbs-text-ellipsis>
      @if (administrator.isProvider) {
        <span
          class="text-gray-600"
          style="margin-left: 19px">
          {{ 'wizards:entityWizards.company.administratorsStep.serviceProvider' | i18next }}
        </span>
      }
    </ng-template>

    <ng-template
      let-administrator
      mbsTableCell>
      <mbs-text-ellipsis
        placement="top-left auto"
        tooltipClass="tooltip-lg"
        [tooltip]="administrator.company">
        {{ administrator.company }}
      </mbs-text-ellipsis>
    </ng-template>
  </mbs-table-grid>
</section>
